const ROOT = "/"
const NEWS = "/news"
const NEWSDETAIL = "/news/detail"
const ANNOUNCEMENT = "/announcement"
const ANNOUNCEMENTDETAIL = "/announcement/detail"
const FAQ = "/faq"
const LPTK = "/lptk"
const LMS = "/lms"
const UKMPPG = "/ukm_ppg"
const GALLERYVIDEO = "/gallery_video"
const GALLERYINFOGRAFIS = "/gallery_infografis"
const EDUCATIONSYSTEM = "/education-system"

export {
    ROOT,
    NEWS,
    NEWSDETAIL,
    ANNOUNCEMENT,
    ANNOUNCEMENTDETAIL,
    FAQ,
    LMS,
    LPTK,
    UKMPPG,
    GALLERYVIDEO,
    GALLERYINFOGRAFIS,
    EDUCATIONSYSTEM,
}